import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import {Link} from 'react-router-dom';

class Footer extends React.Component {
    render() {
      let options = DataStore.getPageBySlug('options');
      var currentYear = new Date().getFullYear();

      return (
        <footer className={`site-footer ${this.props.footerClass ? this.props.footerClass : ''}`}>
          <div className="cnt">
            <div className="copy">
              &copy; {currentYear} Mold Architects<br />
              <Link to="/privacy-statement"> Privacy Statement</Link>
            </div>
            <div className="social">
              <a href={options.acf.facebook} rel="noopener noreferrer">Facebook</a>
              <br /><a href={options.acf.instagram} rel="noopener">Instagram</a>
            </div>
            <div className="credits">
              <a href="http://serifosproperties.com" rel="noopener noreferrer" target="_blank">SERIFOS PROPERTIES.com</a><br />
              Website by <a href="https://nowhere.studio" rel="noopener noreferrer" target="_blank">NOWHERE STUDIO</a>
            </div>
          </div>
        </footer>
      );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/scripts/components/footer.js